import { makeStyles } from "@material-ui/core"

export const bulkPostGroupsStyle = makeStyles((theme) => ({
   
}));